<script setup lang="ts">
import { useProductPrice } from "@shopware-pwa/composables-next";
import type { Product } from "@shopware-pwa/types";
import { Tag } from "~/components/clarity-ui/Tag";
import { TagGroup } from "~/components/clarity-ui/Tag/TagGroup";
import CommonLabel from "~/templates/components/CommonLabel.vue";

export interface ProductBadgeProps {
  product?: Product;
}

const props = defineProps<ProductBadgeProps>();

const { product } = useProduct(props.product);
const { isListPrice } = useProductPrice(product);
const { hasBulkPrice, activeBulkChild } = useProductBulkPrices(product);

const isEvaluatedListPrice = computed(() => {
  return hasBulkPrice.value ? !!activeBulkChild.value?.listPrice : isListPrice.value;
});
</script>

<template>
  <Tag v-if="!product?.available">
    <CommonLabel path="BWF/shop/productCard/soldOutLabel" />
  </Tag>
  <Tag v-else-if="product?.isNew" color="new">
    <CommonLabel path="BWF/shop/productCard/newLabel" />
  </Tag>
  <TagGroup v-else-if="isEvaluatedListPrice || product?.markAsTopseller">
    <Tag v-if="isEvaluatedListPrice" color="deal">
      <CommonLabel path="BWF/shop/productCard/sale" />
    </Tag>
    <Tag v-if="product?.markAsTopseller">
      <CommonLabel path="BWF/shop/productCard/topsellerLabel" />
    </Tag>
  </TagGroup>
</template>
